import { useImmerReducer } from 'use-immer';
import Assessments from './assessments';
import { initialState } from './utils/types';
import { reducer } from './utils/helper';
import { GsapTestResponsesContext } from 'hooks/useGsapGsapTestResponseContext';

type startProps = {
  data: any;
};

const StartGsapTestScreen = (props: startProps) => {
  const gsapResponsesInitialState: initialState = {
    overallTimeLeft: { minutes: 0, seconds: 0 },
    currentQuestion: 0,
    responses: props.data.responses,
    totalQuestions: props.data.responses.length,
    tabSwitchedCount: 0,
  };

  const [state, dispatch] = useImmerReducer(reducer, gsapResponsesInitialState);
  return (
    <GsapTestResponsesContext.Provider value={{ state, dispatch }}>
      <Assessments data={props.data} />
    </GsapTestResponsesContext.Provider>
  );
};

export default StartGsapTestScreen;
